import React from "react";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Settings as SettingsIcon,
} from "@mui/icons-material";

import SettingsTabs from "./SettingsTabs";

function Settings() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography 
          variant={isMobile ? "h4" : "h3"} 
          component="h1" 
          gutterBottom 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            gap: 2,
            color: 'primary.main',
            fontWeight: 600
          }}
        >
          <SettingsIcon color="primary" fontSize={isMobile ? "large" : "inherit"} />
          Settings
        </Typography>
        <Typography 
          variant="body1" 
          color="textSecondary"
          sx={{ maxWidth: 600, mx: 'auto' }}
        >
          Manage your profile, notifications, and account preferences
        </Typography>
      </Box>
      <SettingsTabs />
    </Box>
  );
}

export default Settings;
